export default "__VITE_ASSET__7b42e617__"